import '@alife/panda-i18n/es/style';
